import { AppDispatch } from '../../redux/store';
import CardWrapper from '../wrapper/card';
import CustomInput from '../reusable/input';
import { settingFlagDetails } from '../../redux/slices';
import { updatePasswordSchema } from '../../schema/auth_schema';
import { updatePasswordThunk } from '../../redux/thunks';
import { useDispatch } from 'react-redux';
import { Bounce, toast } from 'react-toastify';
import { Box, Button, Typography } from '@mui/material';
import { Form, Formik } from 'formik';

const UpdatePasswordComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const initialValues = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    };

    const onSubmitHandler = async (values: {
        oldPassword: string;
        newPassword: string;
        confirmPassword: string;
    }) => {
        try {
            await dispatch(updatePasswordThunk({
                current_password: values.oldPassword,
                new_password: values.newPassword
            })).unwrap();
            const data = {
                isEditing: false,
                isUpdatingPassword: false
            };
            dispatch(settingFlagDetails(data));
            toast.success('Password Updated Successfully', {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    theme: 'dark',
                    transition: Bounce
            });
        } catch (e) {
            //
        }
    };

    const onCancelHandler = () => {
        const data = {
            isEditing: false,
            isUpdatingPassword: false
        };
        dispatch(settingFlagDetails(data));
    };

    return (
    <Box p={2}>
        <CardWrapper minHeight="85vh" overflow="auto">
            <Formik initialValues={initialValues} validationSchema={updatePasswordSchema} onSubmit={onSubmitHandler}>
                {({ values, handleChange, handleBlur, errors, touched }) => (
                    <Form>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h4" color="textSecondary">Update Password</Typography>
                            <Box display="flex" gap={1}>
                                <Button variant="contained" type="submit" >Save Password</Button>
                                <Button variant="outlined" color="secondary" onClick={onCancelHandler}>Cancel</Button>
                            </Box>
                        </Box>
                        <CardWrapper>
                            <Box display="flex" gap={2}>
                                <CustomInput
                                    type="password"
                                    label="Current Password"
                                    placeholder="Current Password"
                                    value={values.oldPassword}
                                    onChange={handleChange('oldPassword')}
                                    onBlur={handleBlur('oldPassword')}
                                    error={touched.oldPassword && errors.oldPassword}
                                    fullWidth
                                />
                                <CustomInput
                                    type="password"
                                    label="New Password"
                                    placeholder="New Password"
                                    value={values.newPassword}
                                    onChange={handleChange('newPassword')}
                                    onBlur={handleBlur('newPassword')}
                                    error={touched.newPassword && errors.newPassword}
                                    fullWidth
                                />
                                <CustomInput
                                    type="password"
                                    label="Confirm Password"
                                    placeholder="Confirm Password"
                                    value={values.confirmPassword}
                                    onChange={handleChange('confirmPassword')}
                                    onBlur={handleBlur('confirmPassword')}
                                    error={touched.confirmPassword && errors.confirmPassword}
                                    fullWidth
                                />
                            </Box>
                        </CardWrapper>
                    </Form>
                )}
            </Formik>
        </CardWrapper>
    </Box>
    );
};

export default UpdatePasswordComponent;